import React, { useMemo } from 'react';

import { Button, useTheme } from '@mui/material';
import { getSharedFormStyles } from 'app/pages/loanApplication/LoanApplication.sharedStyles';
import PropTypes from 'prop-types';

import { ChecklistsTestIds } from '../Checklists.testIds';

const ChecklistItemsTableControls = ({
  isFormChanged,
  isEditMode,
  isLoading,
  onToggleEditMode,
}) => {
  const theme = useTheme();
  const classes = useMemo(() => getSharedFormStyles(theme), [theme]);

  return (
    <div className="mb-24 self-end">
      {isEditMode && (
        <>
          <Button
            color="primary"
            data-testid={ChecklistsTestIds.CHECKLIST_ITEMS_CONTROLS_SUBMIT_BUTTON}
            disabled={!isFormChanged || isLoading}
            sx={classes.submitButton}
            type="submit"
            variant="contained"
          >
            Done
          </Button>

          <Button
            data-testid={ChecklistsTestIds.CHECKLIST_ITEMS_CONTROLS_CANCEL_BUTTON}
            disabled={isLoading}
            sx={classes.cancelButton}
            type="button"
            variant="contained"
            onClick={onToggleEditMode}
          >
            Cancel
          </Button>
        </>
      )}

      {!isEditMode && (
        <Button
          data-testid={ChecklistsTestIds.CHECKLIST_ITEMS_CONTROLS_SUBMIT_BUTTON}
          disabled={isLoading}
          type="button"
          variant="contained"
          onClick={onToggleEditMode}
        >
          Edit
        </Button>
      )}
    </div>
  );
};

ChecklistItemsTableControls.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isFormChanged: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  onToggleEditMode: PropTypes.func.isRequired,
};

export default ChecklistItemsTableControls;
